function Logout() {
  localStorage.clear();
  window.location.replace("/");
  // window.location.reload(true);
}

export default Logout;
